import { render, staticRenderFns } from "./MonitoringKelolaStatus.vue?vue&type=template&id=1f6daa0c&scoped=true"
import script from "./MonitoringKelolaStatus.vue?vue&type=script&lang=js"
export * from "./MonitoringKelolaStatus.vue?vue&type=script&lang=js"
import style0 from "./MonitoringKelolaStatus.vue?vue&type=style&index=0&id=1f6daa0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6daa0c",
  null
  
)

export default component.exports